<template>
  <!-- BEGIN SIDEBAR MENU -->
  <div class="sidebar-menu">
    <ul class="menu-items">
      <li class="m-t-30">
        <router-link to="/" exact>
          <span class="title">Dashboard</span>
          <i class="glyphicon glyphicon-th-large"></i>
        </router-link>
      </li>
      <li v-if="isAdmin || isUserManager" class="">
        <router-link :to="{ name: 'users' }" exact>
          <span class="title">Utilisateurs</span>
          <i class="glyphicon glyphicon-user"></i>
        </router-link>
      </li>
      <li class="">
        <router-link :to="{ name: 'customers' }" exact>
          <span class="title">Clients</span>
          <i class="glyphicon glyphicon-list"></i>
        </router-link>
      </li>
      <li class="">
        <router-link :to="{ name: 'prospects' }" exact>
          <span class="title">Contrats en cours</span>
          <i class="glyphicon glyphicon-earphone"></i>
        </router-link>
      </li>
      <li class="">
        <router-link :to="{ name: 'consumptions' }" exact>
          <span class="title">Consommations</span>
          <i class="glyphicon glyphicon-refresh"></i>
        </router-link>
      </li>
      <!--<li class="">
        <router-link :to="{ path: '/404' }">
          <span class="title">Contrat de domiciliation</span>
        </router-link>
      </li>-->
      <!-- <li class="">
        <router-link :to="{ name: 'locations' }">
          <span class="title">Location longue durée</span>
          <i class="glyphicon glyphicon-calendar"></i>
        </router-link>
      </li> -->
      <li class="">
        <router-link :to="{ name: 'one-time-locations' }">
          <span class="title">Location ponctuelle</span>
          <i class="glyphicon glyphicon-blackboard"></i>
        </router-link>
      </li>
      <li class="">
        <router-link :to="{ path: '/hotline' }">
          <span class="title">Permanence téléphonique</span>
          <i class="glyphicon glyphicon-headphones"></i>
        </router-link>
      </li>
      <li class="">
        <router-link :to="{ path: '/crm' }">
          <span class="title">CRM</span>
          <i class="glyphicon glyphicon-comment"></i>
        </router-link>
      </li>
     <!-- <li class="">
        <router-link :to="{ path: '/404' }">
          <span class="title">Affranchissement</span>
        </router-link>
      </li>-->
      <li class="">
        <router-link :to="{ path: '/cash' }">
          <span class="title">Encaissements</span>
          <i class="glyphicon glyphicon-credit-card"></i>
        </router-link>
      </li>
      <li class="">
        <router-link :to="{ path: '/demands' }">
          <span class="title">Demandes</span>
          <i class="glyphicon glyphicon-list-alt"></i>
        </router-link>
      </li>
      <li class="">
        <router-link :to="{ path: '/404' }">
          <span class="title">Messages</span>
          <i class="glyphicon glyphicon-envelope"></i>
        </router-link>
      </li>
      <li class="">
        <router-link :to="{ path: '/catalogs' }">
          <span class="title">Catalogue</span>
          <i class="glyphicon glyphicon-shopping-cart"></i>
        </router-link>
      </li>
      <li class="">
        <router-link :to="{ name: 'loyaltyProgram' }">
          <span class="title">Fidélité</span>
          <i class="glyphicon glyphicon glyphicon-star"></i>
        </router-link>
      </li>
      <!--<li class="">
        <a href="javascript:;">
          <span class="title">Page 3</span>
          <span class=" arrow"></span>
        </router-link>
        <span class="icon-thumbnail"><i class="pg-grid"></i></span>
        <ul class="sub-menu">
          <li class="">
            <a href="">Sub Page 1</router-link>
            <span class="icon-thumbnail">sp</span>
          </li>
          <li class="">
            <a href="">Sub Page 2</router-link>
            <span class="icon-thumbnail">sp</span>
          </li>
          <li class="">
            <a href="">Sub Page 3</router-link>
            <span class="icon-thumbnail">sp</span>
          </li>
        </ul>
      </li>-->
    </ul>
    <div class="clearfix"></div>
  </div>
  <!-- END SIDEBAR MENU -->
</template>

<script type="text/babel">
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters(["isAdmin", "isUserManager"]),
    }
  }
</script>

<style lang="scss" scoped>
  .page-sidebar {
    .sidebar-menu {
      .menu-items {
        li {
          a {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &.router-link-active {
              span {
                color: #fff;
                display: block;
              }
              i {
                color: #fff;
              }
            }
            span {
              display: block;
              font-size: 14px;
              color: #adadad;
            }
            i {
              color: #adadad;
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// client/components/Sidebar/Menu.vue